export default "__VITE_ASSET__ac815d38__"